import { render, staticRenderFns } from "./messageDialog.vue?vue&type=template&id=1fbad4ad&scoped=true"
import script from "./messageDialog.vue?vue&type=script&lang=js"
export * from "./messageDialog.vue?vue&type=script&lang=js"
import style0 from "./messageDialog.vue?vue&type=style&index=0&id=1fbad4ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbad4ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fbad4ad')) {
      api.createRecord('1fbad4ad', component.options)
    } else {
      api.reload('1fbad4ad', component.options)
    }
    module.hot.accept("./messageDialog.vue?vue&type=template&id=1fbad4ad&scoped=true", function () {
      api.rerender('1fbad4ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/component/messageDialog.vue"
export default component.exports